import React from "react";

export default function TermsandCondition() {
  const brandGreen = "#1ac942";

  return (
    <section style={styles.section}>
      <div style={styles.container}>
        <h1 style={styles.title}>Terms & Conditions</h1>

        <p style={styles.text}>
          By accessing and using the BioSurge website, you agree to comply with and
          be bound by the following Terms and Conditions.
        </p>

        <h3 style={styles.heading}>1. Product Usage</h3>
        <p style={styles.text}>
          All BioSurge products are intended for personal wellness and general health
          support only. They are not meant to diagnose, treat, cure, or prevent any disease.
        </p>

        <h3 style={styles.heading}>2. Order Acceptance</h3>
        <p style={styles.text}>
          We reserve the right to accept or cancel any order due to product availability,
          pricing errors, or suspicious transactions.
        </p>

        <h3 style={styles.heading}>3. Pricing Policy</h3>
        <p style={styles.text}>
          Prices displayed on the website are subject to change without prior notice.
          We strive for accuracy but do not guarantee error-free pricing.
        </p>

        <h3 style={styles.heading}>4. Intellectual Property</h3>
        <p style={styles.text}>
          All website content including logos, product images, and text are the property
          of BioSurge and may not be copied or reused without permission.
        </p>

        <h3 style={styles.heading}>5. User Responsibilities</h3>
        <p style={styles.text}>
          Users agree not to misuse the website for unlawful activities or fraudulent transactions.
        </p>

        <h3 style={styles.heading}>6. Limitation of Liability</h3>
        <p style={styles.text}>
          BioSurge shall not be liable for any indirect or consequential damages arising
          from product usage or website access.
        </p>

        <h3 style={styles.heading}>7. Governing Law</h3>
        <p style={styles.text}>
          These Terms shall be governed by and interpreted under the laws of India.
        </p>
      </div>
    </section>
  );
}

const styles = {
  section:{padding:"60px 20px",background:"#000",minHeight:"100vh"},
  container:{maxWidth:"850px",margin:"0 auto",color:"#ccc"},
  title:{fontSize:"40px",color:"#fff",textAlign:"center",marginBottom:"20px"},
  heading:{color:"#1ac942",marginTop:"25px"},
  text:{lineHeight:"1.7"}
};